import { useState } from 'react';
import Team from '../../components/Team.jsx';
import '../../css/FootballTeams.css';
import afcTeamLogos from '../../assets/AFCteamLogos';

const teamsData = Object.keys(afcTeamLogos).map((teamName) => ({
    name: teamName,
    img: afcTeamLogos[teamName]
}));

const AfcTeamsPage = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredTeams = teamsData.filter((team) =>
        team.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <main id="football-teams-content">
            <h2 id="quest">AFC Teams</h2>

            <input
                type="text"
                placeholder="Search teams..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    margin: '1rem 0',
                    marginLeft: '10px',
                    padding: '0.5rem',
                    fontSize: '1rem',
                    width: '250px',
                    background: '#fff',
                    color: '#111'
                }}
            />

            <section id="football-teams-section">
                {filteredTeams.map((team) => (
                    <Team
                    key={team.name}
                    img={team.img}
                    name={team.name}
                    to={`/sports/football/afc/teams/${team.name.toLowerCase().replace(/ /g, "-")}`}
                />
                ))}
            </section>
        </main>
    );
};

export default AfcTeamsPage;